/* Passive BYOB observer. No provider APIs, cart POSTs, DOM writes, cookie writes or fetch wrapping. */
(function () {
  'use strict';
  var configNode = document.getElementById('malezia-byob-shadow-config');
  var config;
  try { config = JSON.parse(configNode && configNode.textContent || '{}'); } catch (_) { return; }
  if (config.enabled !== true || config.nativeEnabled !== false ||
      config.collector !== 'byob-shadow-v1' || !/^[0-9]{1,24}$/.test(String(config.themeId)) ||
      !window.crypto || !window.crypto.subtle) return;
  var theme = window.Shopify && window.Shopify.theme;
  // Observed Shopify role is authoritative; URL flags cannot relabel a live page.
  var source = theme && theme.role === 'unpublished' ? 'preview' :
    theme && theme.role === 'main' ? 'live' : 'unknown';
  if (source === 'unknown' || String(theme && theme.id) !== String(config.themeId)) return;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  if (!/^\/[a-zA-Z0-9/-]*\/$/.test(root) && root !== '/') return;
  var previous = null, busy = false, reads = 0, seen = new Set();
  var timer;
  function hash(value) {
    return window.crypto.subtle.digest('SHA-256',new TextEncoder().encode(value)).then(function (bytes) {
      return Array.from(new Uint8Array(bytes)).map(function (b) { return b.toString(16).padStart(2,'0'); }).join('');
    });
  }
  function select(cart) {
    if (!cart || typeof cart.token !== 'string' || !Array.isArray(cart.items) ||
        !cart.items.length || cart.items.length > 40) return null;
    var lines = cart.items.map(function (item) {
      var p = item.properties || {};
      return {
        variantId: String(item.variant_id), productId: String(item.product_id), quantity: item.quantity,
        builder: String(p._widget_id) === '291601',
        role: p._source === 'Rebuy' && p._attribution === 'Rebuy Bundle Builder Gift With Purchase' ? 'gift' :
          p._source === 'Rebuy' && ['Rebuy Bundle Builder','Rebuy Bundle Builder Subscription'].indexOf(p._attribution) >= 0 ? 'paid' : 'unknown',
        native: Object.keys(p).some(function (key) { return key.indexOf('_malezia_') === 0; }),
        session: typeof p._r_added_bundle_session_id === 'string' ? p._r_added_bundle_session_id : null,
        sellingPlanId: item.selling_plan_allocation ? String(item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) : null,
        planPriceCents: item.selling_plan_allocation && Number.isSafeInteger(item.selling_plan_allocation.price) ? item.selling_plan_allocation.price : null,
        originalCents: item.original_line_price, finalCents: item.final_line_price,
        allocations: Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations.map(function (a) {
          var d = a.discount_application || {};
          return {cents:a.amount,type:typeof d.type === 'string' ? d.type : '',title:typeof d.title === 'string' ? d.title : ''};
        }) : null
      };
    });
    if (!lines.some(function (line) { return line.builder; })) return null;
    return {currency:cart.currency,cartDiscount: !Array.isArray(cart.cart_level_discount_applications) || cart.cart_level_discount_applications.length > 0,lines:lines};
  }
  async function sample() {
    if (busy || document.visibilityState !== 'visible') return;
    if (reads >= 120) { clearInterval(timer); return; }
    // If ownership changes during this page lifetime, refuse rather than touch the new provider.
    if (document.documentElement.classList.contains('malezia-merch-on') || document.body.classList.contains('malezia-merch-on')) {
      clearInterval(timer); return;
    }
    busy = true; reads++;
    try {
      var response = await window.fetch(root+'cart.js',{method:'GET',credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(5000)});
      if (!response.ok) { previous = null; return; }
      var cart = await response.json();
      var selected = select(cart);
      if (!selected) { previous = null; return; }
      var cartHash = await hash('malezia-byob-shadow-v1:'+cart.token);
      var stable = JSON.stringify({cartHash:cartHash,selected:selected});
      // Two equal consecutive snapshots >=15s apart; reads do not trigger cart changes.
      // This is stability evidence only, not a claim Rebuy has a transactional settled event.
      if (stable !== previous) { previous = stable; return; }
      var fingerprint = await hash(stable);
      if (seen.has(fingerprint)) return;
      seen.add(fingerprint); // no retry on uncertain network results; DB also deduplicates
      var body = JSON.stringify(Object.assign({collector:'byob-shadow-v1',cartHash:cartHash,
        ts:Date.now(),source:source,themeId:String(config.themeId)},selected));
      if (body.length > 32768) return;
      await window.fetch('/apps/malezia-merch/shadow',{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},body:body,signal:AbortSignal.timeout(5000)});
    } catch (_) { previous = null; } finally { busy = false; }
  }
  timer = setInterval(sample,15000);
  window.addEventListener('pagehide',function () { clearInterval(timer); },{once:true});
  sample();
})();
